<template>
  <div class="grid m-0 content">
    <div
      id="left"
      class="col-12 md:col-8"
    >
      <div class="content-flexible">
        <div
          id="header"
          class="mb-3"
        >
          <LocaleChooserComponent id="locale-chooser" />
          <img
            v-if="applicationLogo"
            alt="logo"
            :src="applicationLogo"
          >
          <h2>Test & Tagging</h2>
        </div>
        <slot />
      </div>
    </div>
    <div
      id="right"
      class="col-4 hidden md:inline-flex min-h-full"
    />
  </div>
  <FooterComponent />
</template>

<script>
import LocaleChooserComponent from "@/components/LocaleChooserComponent";
import FooterComponent from "@/components/FooterComponent";
import mixin from '../mixin/logoUrlMixins'

export default {
  name: "OfflineLayout",
  components: { FooterComponent, LocaleChooserComponent },
  mixins: [mixin],
};
</script>

<style lang="scss" scoped>
#locale-chooser {
  float: right;
}

#right {
  background-image: url("../assets/images/offline_side_image.png");
  background-size: cover;
}

#menu a {
  text-decoration: none;
  margin-right: 20px;
}

.content {
  min-height: 95vh;
}

.content-flexible {
  padding: 48px;

  @media (max-width: 768px) {
    padding: 20px;

  }
}
</style>
